import { useFeatureFlags } from '@funtech-int/yango-shared';

export function useYaspVersion(): string | undefined {
    const yaspVersion = useFeatureFlags().flags.get('yaspVersion', 'string', '');

    if (typeof yaspVersion === 'string' && yaspVersion.length > 0) {
        return yaspVersion;
    }
}
